import Page, { PageHero } from "../components/Page";
import SubNav from "../components/SubNav";
import { festival } from "../data/festival";
import { IconFacebook, IconInstagram } from "../components/icons";
import styles from "./Contact.module.css";

const aboutSubNav = [
  { label: "About", path: "/about", end: true },
  { label: "Venue Info", path: "/about/venue" },
  { label: "FAQ", path: "/about/faq" },
  { label: "SFMA", path: "/about/sfma" },
  { label: "Press", path: "/about/press" },
  { label: "Contact", path: "/about/contact" },
];

const inboxes = [
  { label: "General", email: festival.email, blurb: "Anything we haven't covered." },
  { label: "Volunteers", email: festival.emailVolunteer, blurb: "Festival volunteer applications and questions." },
  { label: "Sponsors", email: festival.emailSponsor, blurb: "Sponsorship packages, on-site activations, stage naming." },
  { label: "Vendors", email: festival.emailVendor, blurb: "Food and goods vending applications." },
  { label: "Press", email: festival.emailPress, blurb: "Photo passes, review credentials, interview requests." },
  { label: "Artists", email: festival.emailArtists, blurb: "Booking and lineup inquiries." },
];

export default function Contact() {
  return (
    <>
      <PageHero
        eyebrow="Get in touch"
        title="Contact"
        lede="The right inbox for the right question gets the fastest answer."
        image="/photos/festival-1.jpg"
      />
      <SubNav items={aboutSubNav} />

      <Page>
        <div className={styles.grid}>
          {inboxes.map((i) => (
            <a key={i.label} href={`mailto:${i.email}`} className={styles.card}>
              <span className={styles.eyebrow}>{i.label}</span>
              <span className={styles.email}>{i.email}</span>
              <span className={styles.blurb}>{i.blurb}</span>
            </a>
          ))}
        </div>

        <section className={styles.address}>
          <div>
            <h3 className={styles.h}>Mailing</h3>
            <p>{festival.mailing}</p>
          </div>
          <div>
            <h3 className={styles.h}>Festival Site</h3>
            <p>{festival.address}</p>
          </div>
          <div>
            <h3 className={styles.h}>Find us</h3>
            <div className={styles.social}>
              <a href={festival.facebook} target="_blank" rel="noopener" aria-label="Facebook">
                <IconFacebook />
              </a>
              <a href={festival.instagram} target="_blank" rel="noopener" aria-label="Instagram">
                <IconInstagram />
              </a>
            </div>
          </div>
        </section>
      </Page>
    </>
  );
}
